import React from 'react';
import I18n from 'i18n-js';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { getYear } from '../lib/date_utils';

interface IProps extends IUserContext {
  ordersCount: number;
  createdAt: string;
}

export function formatOrdersCount(count) {
  if (count >= 1000) {
    return Math.floor(count / 1000) * 1000;
  }
  if (count >= 100) {
    return Math.floor(count / 100) * 100;
  }
  if (count >= 10) {
    return Math.floor(count / 10) * 10;
  }
  return 0;
}

export function ShopStats(props: IProps) {
  const { createdAt, ordersCount } = props;
  const foundingYear = getYear(createdAt);
  const count = formatOrdersCount(ordersCount);

  return (
    <div className="mt-half" data-shop-stats>
      <div className="size-80 opacity-80 lh-130 d-flex">
        {count > 0 &&
          <div className="mr-2">
            <div>
              {I18n.t('discovery.item2Shop.sales')}
            </div>
            <div className="weight-bold">
              {`${count}+`}
            </div>
          </div>
        }
        <div>
          <div>
            {I18n.t('discovery.item2Shop.joined')}
          </div>
          <div className="weight-bold">
            {foundingYear}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withUserContext<IProps>(ShopStats);
